import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Megaphone, X } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export function AnnouncementBanner({ role }) {
  const navigate = useNavigate();
  const [latest, setLatest] = useState(null);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (role === "grantee") return;
    api.get("/announcements").then(({ data }) => {
      const top = (data || [])[0];
      if (!top) return;
      setLatest(top);
      try { setDismissed(localStorage.getItem(`accord_announce_${top.id}`) === "1"); }
      catch { setDismissed(false); }
    }).catch(() => {});
  }, [role]);

  if (!latest || dismissed || role === "grantee") return null;

  const close = () => {
    try { localStorage.setItem(`accord_announce_${latest.id}`, "1"); } catch {}
    setDismissed(true);
  };

  return (
    <div data-testid="announcement-banner" className="relative mb-6 rounded-lg border border-gold/40 bg-gradient-to-r from-primary to-primary/90 text-white px-5 py-4 flex items-start gap-3">
      <Megaphone size={22} weight="fill" className="text-gold shrink-0 mt-0.5" />
      <div className="flex-1 pr-6">
        <div className="font-head font-semibold text-sm">{latest.title}</div>
        <div className="text-sm text-white/80 mt-0.5">{latest.body}</div>
        <div className="mt-2 flex items-center gap-4">
          {latest.cta_to && latest.cta_label && (
            <button data-testid="announcement-cta" onClick={() => navigate(latest.cta_to)} className="text-sm font-medium text-gold hover:underline">
              {latest.cta_label} →
            </button>
          )}
          <button data-testid="announcement-see-all" onClick={() => navigate("/whats-new")} className="text-sm font-medium text-white/80 hover:text-white hover:underline">
            See all updates
          </button>
        </div>
      </div>
      <button data-testid="announcement-dismiss" onClick={close} className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors">
        <X size={16} />
      </button>
    </div>
  );
}
